import { render, staticRenderFns } from "./WeeklyContestComponent.vue?vue&type=template&id=7d8243fd&"
import script from "./WeeklyContestComponent.vue?vue&type=script&lang=ts&"
export * from "./WeeklyContestComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WeeklyContestComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports